import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LOGO_URL, PLATAFORMA_NAV_LINKS } from '../data';

export default function PlataformaNavbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goToSection = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav
      aria-label="Navegação principal"
      className={`absolute left-1/2 top-3 z-50 w-[min(1240px,94%)] -translate-x-1/2 rounded-2xl border border-white/10 backdrop-blur-md transition-colors duration-300 md:top-4 md:rounded-full ${
        scrolled ? 'bg-foreground-950/95' : 'bg-foreground-950/90'
      }`}
    >
      <div className="flex h-16 items-center justify-between gap-3 px-5 md:h-[72px] md:px-7">
        <div className="flex shrink-0 items-center gap-3 md:gap-5">
          <button
            type="button"
            onClick={() => navigate('/')}
            aria-label="Ir para a página inicial"
            className="flex cursor-pointer items-center"
          >
            <img src={LOGO_URL} alt="GetPoints" className="h-9 w-auto md:h-10" />
          </button>
          <span className="hidden rounded-full bg-primary-500 px-4 py-1.5 text-sm font-semibold text-white sm:inline-block">
            Plataforma
          </span>
        </div>

        <div className="hidden items-center gap-1 lg:flex">
          {PLATAFORMA_NAV_LINKS.map((link) => (
            <button
              key={link.href}
              type="button"
              onClick={() => goToSection(link.href)}
              className="cursor-pointer whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium text-background-100/75 transition-colors hover:bg-white/10 hover:text-background-50"
            >
              {link.label}
            </button>
          ))}
        </div>

        <div className="hidden items-center lg:flex">
          <button
            type="button"
            onClick={() => navigate('/solicitar-demo')}
            className="inline-flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-white/25 px-5 text-sm font-semibold text-background-50 transition-colors hover:bg-white/10"
          >
            Solicitar demonstração
            <i className="ri-arrow-right-line text-base"></i>
          </button>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((value) => !value)}
          aria-label={menuOpen ? 'Fechar menu de navegação' : 'Abrir menu de navegação'}
          aria-expanded={menuOpen}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full text-background-50 transition-colors hover:bg-white/10 lg:hidden"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="px-4 pb-4 pt-1 lg:hidden">
          <div className="rounded-2xl border border-white/10 bg-foreground-950/95 p-2">
            {PLATAFORMA_NAV_LINKS.map((link) => (
              <button
                key={link.href}
                type="button"
                onClick={() => goToSection(link.href)}
                className="w-full cursor-pointer rounded-xl px-4 py-3 text-left text-sm font-medium text-background-100/85 transition-colors hover:bg-white/10 hover:text-background-50"
              >
                {link.label}
              </button>
            ))}
            <button
              type="button"
              onClick={() => {
                setMenuOpen(false);
                navigate('/solicitar-demo');
              }}
              className="mt-2 inline-flex h-11 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-white/25 text-sm font-semibold text-background-50 transition-colors hover:bg-white/10"
            >
              Solicitar demonstração
              <i className="ri-arrow-right-line text-base"></i>
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}